module.exports = __webpack_public_path__ + "static/media/people-821624_960_720.9bb18ac8.jpg";